import { useStore } from '@/store'
import Topbar         from '@/components/layout/Topbar'
import Trackbar       from '@/components/layout/Trackbar'
import FilterBar      from '@/components/filters/FilterBar'
import MetricRow      from '@/components/ui/MetricRow'
import StubView       from '@/views/StubView'
import UsersView      from '@/views/users/UsersView'
import StreamsView    from '@/views/StreamsView'
import SettingsView   from '@/views/SettingsView'
import ReportsView    from '@/views/ReportsView'
import DataController from '@/analysis/DataController'
import VizTableSplit  from './VizTableSplit'
import { STUB_PAGES, isStubView } from '@/routing/stubPages'

// Right-hand column of the app shell: top bars, the viz/table area, footer.
export default function MainContent() {
  const view = useStore(s => s.view)

  let body: React.ReactNode
  if (view === 'users') {
    body = <UsersView />
  } else if (view === 'streams') {
    body = <StreamsView />
  } else if (view === 'settings') {
    body = <SettingsView />
  } else if (view === 'reports') {
    body = <ReportsView />
  } else if (isStubView(view)) {
    body = <StubView title={STUB_PAGES[view].title} subtitle={STUB_PAGES[view].subtitle} />
  } else {
    body = <VizTableSplit />
  }

  const showFilters = view === 'world' || view === 'hex' || view === 'deep'

  return (
    <div style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden', minHeight: 0 }}>
      <DataController />
      <Topbar />
      {showFilters ? <FilterBar /> : null}
      <div style={{ flex: 1, overflow: 'auto', padding: 12, display: 'flex', flexDirection: 'column', gap: 10 }}>
        {view === 'world' && <MetricRow />}
        {body}
      </div>
      <Trackbar />
    </div>
  )
}
